exports.DELIVERY_PLATFORM_DCM = 'dcm';
exports.DELIVERY_PLATFORM_TTD = 'ttd';

exports.DELIVERY_PLATFORMS = {
    dcm: exports.DELIVERY_PLATFORM_DCM,
    ttd: exports.DELIVERY_PLATFORM_TTD
};



// WEBPACK FOOTER //
// ./src/constants/deliveryPlatforms.js